import React from "react";
import ProductForm from "./components/ProductForm";

const AddProduct = () => {
  return <ProductForm isEdit={false} />;
};

export default AddProduct;
